// Resend API integration
// Replace RESEND_API_KEY with your actual key from resend.com/api-keys
const RESEND_API_KEY = 're_TV5MdTBH_C62BXij7H6FXgdigN2viUve7' // ← Paste your Resend API key here

export interface DemoFormData {
  name: string
  email: string
  phone: string
  role: string
  company: string
}

export async function sendDemoEmail(data: DemoFormData): Promise<void> {
  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 24px; background: #FAFAF8; border-radius: 12px;">
      <div style="background: #E8500A; padding: 16px 24px; border-radius: 8px 8px 0 0;">
        <h2 style="color: white; margin: 0; font-size: 20px;">🎉 New Demo Request — The Yarn Bazaar</h2>
      </div>
      <div style="background: white; padding: 24px; border-radius: 0 0 8px 8px; border: 1px solid #E8E4DC;">
        <table style="width: 100%; border-collapse: collapse;">
          <tr style="border-bottom: 1px solid #F0EDE8;">
            <td style="padding: 12px 0; color: #9B9890; font-size: 13px; width: 120px;">Full Name</td>
            <td style="padding: 12px 0; color: #0F0E0C; font-size: 14px; font-weight: 600;">${data.name}</td>
          </tr>
          <tr style="border-bottom: 1px solid #F0EDE8;">
            <td style="padding: 12px 0; color: #9B9890; font-size: 13px;">Email</td>
            <td style="padding: 12px 0; color: #0F0E0C; font-size: 14px; font-weight: 600;">${data.email}</td>
          </tr>
          <tr style="border-bottom: 1px solid #F0EDE8;">
            <td style="padding: 12px 0; color: #9B9890; font-size: 13px;">Phone</td>
            <td style="padding: 12px 0; color: #0F0E0C; font-size: 14px; font-weight: 600;">${data.phone}</td>
          </tr>
          <tr style="border-bottom: 1px solid #F0EDE8;">
            <td style="padding: 12px 0; color: #9B9890; font-size: 13px;">Role</td>
            <td style="padding: 12px 0; color: #0F0E0C; font-size: 14px; font-weight: 600;">${data.role || '—'}</td>
          </tr>
          <tr>
            <td style="padding: 12px 0; color: #9B9890; font-size: 13px;">Company</td>
            <td style="padding: 12px 0; color: #0F0E0C; font-size: 14px; font-weight: 600;">${data.company || '—'}</td>
          </tr>
        </table>
        <div style="margin-top: 20px; padding: 12px 16px; background: #FFF7F3; border-radius: 8px; border-left: 3px solid #E8500A;">
          <p style="margin: 0; color: #C04008; font-size: 12px;">Submitted via theyarnbazaar.com · ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })} IST</p>
        </div>
      </div>
    </div>
  `

  const response = await fetch('https://api.resend.com/emails', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${RESEND_API_KEY}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      from: 'The Yarn Bazaar <noreply@heybella.online>',
      to: ['vishaldarak879@gmail.com'],
      subject: `New Demo Request from ${data.name} — ${data.company || data.role || 'The Yarn Bazaar'}`,
      html,
      reply_to: data.email,
    }),
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.message || 'Failed to send email')
  }
}
